import axios from "axios";
import i18n from "../../i18n.js";

const state = {
  instance: {
    suppliers: [],
    theme: {},
    preload: {}
  },
  supplier: { id: 0 },
  polygon: { polygon_found: null }
};

const getters = {
  instance_id: state => {
    return state.instance.id;
  },
  supplier_id: state => {
    return state.supplier.id;
  },
  pixel_google_analytics: state => {
    return state.instance.pixel_google_analytics;
  },
  pixel_facebook_analytics: state => {
    return state.instance.pixel_facebook_analytics;
  },
  has_cluvipay: state => {
    return state.supplier.has_cluvi_pay
  },
  // eslint-disable-next-line no-unused-vars
  is_ontable_checkout: (state, getters, rootState, rootGetters) => {
    return state.supplier.on_table_class == 'checkout' && rootGetters['order/is_ontable_service'] && rootState.ontable.tableId !== '';
  },
  // eslint-disable-next-line no-unused-vars
  is_ontable_basic: (state, getters, rootState, rootGetters) => {
    return state.supplier.on_table_class == 'basic' &&
        rootGetters['order/is_ontable_service'] ||
        (
          !getters.is_ontable_mylist &&
          !getters.is_ontable_plazoleta &&
          !getters.is_ontable_noincremental &&
          !getters.is_ontable_checkout
        )
  },
  // eslint-disable-next-line no-unused-vars
  is_ontable_mylist: (state, getters, rootState, rootGetters) => {
    return state.supplier.on_table_class == 'my-list' && rootGetters['order/is_ontable_service'];
  },
  // eslint-disable-next-line no-unused-vars
  is_ontable_plazoleta: (state, getters, rootState, rootGetters) => {
    return state.supplier.on_table_class == 'checkout_plazoleta' && rootGetters['order/is_ontable_service'];
  },
  // eslint-disable-next-line no-unused-vars
  is_ontable_noincremental: (state, getters, rootState, rootGetters) => {
    return state.supplier.on_table_class == 'checkout_no_incremental' && rootGetters['order/is_ontable_service'] && rootState.ontable.tableId !== '';

  },
  // eslint-disable-next-line no-unused-vars
  mandatory_payment: (state, getters, rootState, rootGetters) => {
    return getters.is_ontable_noincremental || getters.is_ontable_plazoleta || rootGetters.is_room_service
  },
  // eslint-disable-next-line no-unused-vars
  mandatory_send_to_prepare: (state, getters) => {
    return getters.is_ontable_checkout;
  },
  is_colombian_customer: (state) => {
    return state.instance.country_code === 'CO';
  },
  is_mexican_customer:(state) => {
    return state.instance.country_code === 'MX';
  },
  price_currency_locale:(state) => (price) => {
    let currencylocale = '';
    switch (state.instance.currency) {
        case 'MXN':
          currencylocale = 'es-MX';
          break;
        case 'PEN':
          currencylocale = 'es-PE';
          break;
        case 'CLP':
          currencylocale = 'es-CL';
          break;
        case 'USD':
          currencylocale = 'en-US';
          break;
        case 'BRL':
          currencylocale = 'pt-BR';
          break;
        default:
          currencylocale = 'es-CO';
          break;
    }
    return i18n.n(price, 'currency', currencylocale);
  },
  getLabels:  (state) => (tag) => {
    const labels = i18n.t(tag);
    const key = Object.keys(labels).find(x => x === state.instance.country_code);
    if (key) {
      return labels[key];
    } else {
      return labels['DEFAULT'];
    }
  },
  is_peruvian_customer:(state) => {
    return state.instance.country_code === 'PE';
  }

  //pago obligatio: no incremental o food_court, room_service(checkout tradicional);
  // checkout envio a preparar
  //menu-digital path para
  //grab-and-go path para pedido en plazoleta no incremental
  //si escaneo, y la validación no es correcta (el servicio), lo llevo al menú básico.
  // si es checkout  debe tener mesa y si es grab-and-go, set menu básico.
  //
};

const actions = {
  async InitInstance({commit, dispatch}) {
    const url = `${process.env.VUE_APP_API_EXP}/domain/config.json`;
    const res = await axios.get(url);
    commit("customer/SetConfig", res.data, {root: true});
    dispatch("profile/InitSession", null, {root: true});
  },
  async GetSupplier({commit}, slug) {
    const url = `${process.env.VUE_APP_API_EXP}/domain/suppliers/${slug}.json`;
    const res = await axios.get(url);
    commit("customer/SetSupplier", res.data, {root: true});
  },
  async GetSupplierByBranch({commit}, id) {
    const url = `${process.env.VUE_APP_API_EXP}/domain/branches/${id}.json`;
    const res = await axios.get(url);
    commit("customer/SetSupplier", res.data, {root: true});
  }
};

const mutations = {
  SetConfig(state, data) {
    state.instance = data;
  },
  SetSupplier(state, supplier) {
    state.supplier = supplier;
  },
  SetPolygon(state, data) {
    state.polygon = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
